import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { Cnt } from "../Cnt.ThreeDeeCrate.SDK/Cnt.ThreeDeeCrate.SDK";

interface Props {
  show: boolean;
  onClose: () => void;
  onSave: () => void;
  editMode: boolean;
  name: string;
  description: string;
  type: number;
  visibility: number; // 0 = Private, 1 = Public
  setName: (val: string) => void;
  setDescription: (val: string) => void;
  setType: (val: number) => void;
  setVisibility: (val: number) => void;
}

export const CreateEditModal: React.FC<Props> = ({
  show,
  onClose,
  onSave,
  editMode,
  name,
  description,
  type,
  visibility,
  setName,
  setDescription,
  setType,
  setVisibility,
}) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{editMode ? "Edit Container" : "Add New Container"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Type</Form.Label>
            <Form.Select value={type} onChange={(e) => setType(Number(e.target.value))}>
              <option value={Cnt.ThreeDeeCrate.SDK.ContainerType.Container}>Container</option>
              <option value={Cnt.ThreeDeeCrate.SDK.ContainerType.SearchContainer}>Search Container</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Visibility</Form.Label>
            <Form.Select value={visibility} onChange={(e) => setVisibility(Number(e.target.value))}>
              <option value={Cnt.ThreeDeeCrate.SDK.VisibilityType.Private}>Private</option>
              <option value={Cnt.ThreeDeeCrate.SDK.VisibilityType.Public}>Public</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button variant="primary" onClick={onSave}>{editMode ? "Update" : "Create"}</Button>
      </Modal.Footer>
    </Modal>
  );
};
